<template>
  <div v-if="stock">
    <div class="entete border-entete">
        <div class="is-paddingless section">
          <div class="level">
            <div class="level-left">
              <div class="columns is-gapless">
                <div class="column">
                  <h1 class="title is-size-3">
                    {{ $t('stock.detailStock.title', {bon: bon}) }}
                    <b-tag v-if="!stock.actif"
                        type="has-background-subMenu"
                        class="has-text-white mgl-5px">
                        {{$t('detailEmplacement.archive')}}
                </b-tag>
                  </h1>
                  <app-breadcrumb :breadcrumb="breadcrumb" />
                </div>
              </div>
            </div>
            <div class="level-right">
               <div class="buttons">
                <dropdownButton
                  type="is-addOrEdit"
                  class="mgr-2"
                  :permission="stockPerm.maj"
                  :actions="insertActionSecondary"
                  @click="() => {
                      $router.push({ name: this.modifRoute,
                        params: {id: this.stock.id}});
                  }">
                  {{ $t('detail.buttons.edit') }}&nbsp;
                </dropdownButton>
               </div>
            </div>
          </div>
        </div>
    </div>
    <div class="pdt-20px">
        <div class="card">
        <header class="header-card">
          <p>
            {{ $t('stock.generalTitle.generalInformations')}}
          </p>
        </header>
        <div class="card-content">
          <b-field class="columns is-multiline">
            <div class="column is-4">
                <p class="has-text-default is-italic">
                  {{ dateDeBonLibelle }}
                </p>
                <p class="has-text-weight-bold is-narrow">
                  {{ formatDate(stock.dateBon) }}
                </p>
            </div>
            <div class="column is-4">
                <p class="has-text-default is-italic">
                  {{ $t('stock.informations.lieuDeStockage') }}
                </p>
                <router-link target="_blank" :to="{ name: 'c.bodac.clients/contacts-client',
                  params: {id: stock.lieuDeStockageId}}"
                    class="lien has-text-weight-bold is-narrow"
                    :class="{'text-access-no-permission':
                  !checkPermissions(stockPerm.lecture)}">
                  {{ stock.lieuDeStockage.nomCommercial }}
                </router-link>
            </div>
            <div class="column is-4">
                <p class="has-text-default is-italic">
                  {{ $t('stock.informations.origine') }}
                </p>
                <p class="has-text-weight-bold is-narrow">
                    {{getOriginLibelle(stock.origine)}}
                </p>
            </div>
          </b-field>
        </div>
    </div>
    <div class="pdt-20px">
        <div class="card">
            <header class="header-card">
                <p>
                    {{ $t('stock.generalTitle.mouvementStock')}}
                </p>
            </header>
            <div class="card-content">
                <div class="column is-6">
                    <v-client-table
                        :data="stock.mouvements"
                        :columns="columns"
                        :options="options"
                        ref="tableItems">
                        <template #produit="{ row }">
                            {{ row.produit.libelle }}
                        </template>
                        <template #quantite="{ row }" >
                          <div class="is-pulled-right">
                            {{ row.quantite }}
                          </div>
                        </template>
                    </v-client-table>
                </div>
            </div>
        </div>
    </div>
    <div class="pdt-20px">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('stock.generalTitle.commentaire')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12" v-if="stock.commentaire">
              <p class="has-text-default is-italic">
                {{ $t('stock.generalTitle.commentaire') }}
              </p>
              <p class="has-text-weight-bold is-narrow">
                  {{ stock.commentaire }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <b-modal
      v-model="popup"
      has-modal-card
      class="modal"
      @close="popup = false">
      <popUpPrevention
        :messHeader="title"
        :messFooter="subtitle"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @yes="action()"
        @no="popup = false"
      />
    </b-modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import {
  BONS_ENTREE,
  BONS_SORTIE,
  BON_ENTREE,
  BON_SORTIE,
  EDITION_BON_ENTREE_ROUTE,
  EDITION_BON_SORTIE_ROUTE,
  LISTE_BON_ENTREE_ROUTE,
  LISTE_BON_SORTIE_ROUTE,
  DATE_DE_BON_ENTREE,
  DATE_DE_BON_SORTIE,
  ORIGINE_BON_DIVERS,
  ORIGINE_TYPE_DIVERS,
  ORIGINE_COMMANDE,
  BON_ENTREE_MAJ, BON_SORTIE_MAJ, BON_STOCK_TYPE_ENTREE,
  DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID,
  ORIGINE_TYPE_COMMANDE, BON_STOCK_TYPE_SORTIE,
} from '@/configuration/bonStock/menuStockConf';
import { BON_STOCK } from '@/configuration/bonStock/permissionsStockConf';
import dropdownButton from '@/components/general/button/dropdownButton';
import {
  TEXTS,
  SORT_ICON,
} from '@/configuration/clientTableConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import {
  get, archiver, remove, getByLigneCommandeId,
} from '@/api/gabed/bonStock';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      stock: null,
      stockPerm: BON_STOCK,
      popup: false,
      option: null,
      title: null,
      subtitle: null,
      isEntree: false,
      formatDate,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    dropdownButton,
    popUpPrevention,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          produit: this.$t('stock.tab.produit'),
          quantite: this.$t('stock.tab.quantite'),
        },
        filterable: false,
        texts: TEXTS,
        sortable: ['produit'],
      };
    },
    columns() {
      return ['produit', 'quantite'];
    },
    type() {
      return this.isEntree ? this.$t(BONS_ENTREE) : this.$t(BONS_SORTIE);
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('stock.breadcrumb.liste', { bons: this.type }), route: this.route, isActive: false },
        { title: this.$t('stock.detailStock.title', { bon: this.bon }), route: '', isActive: true },
      ];
    },
    route() {
      return {
        name: this.isEntree ? LISTE_BON_ENTREE_ROUTE
          : LISTE_BON_SORTIE_ROUTE,
      };
    },
    modifRoute() {
      return this.isEntree ? EDITION_BON_ENTREE_ROUTE : EDITION_BON_SORTIE_ROUTE;
    },
    bon() {
      return this.isEntree ? this.$t(BON_ENTREE) : this.$t(BON_SORTIE);
    },
    bonMaj() {
      return this.isEntree ? this.$t(BON_ENTREE_MAJ) : this.$t(BON_SORTIE_MAJ);
    },
    insertActionSecondary() {
      const actionSecondary = [
        {
          label: this.stock.actif ? this.$t('stock.actions.archiver')
            : this.$t('stock.actions.desarchiver'),
          action: () => {
            this.option = 'archiver';
            this.title = this.stock.actif
              ? this.$t('stock.popUpArchivage.titleArchiver', { bon: this.bon })
              : this.$t('stock.popUpArchivage.titleDesarchiver', { bon: this.bon });
            this.subtitle = null;
            this.popup = true;
          },
          permissionAction: this.stockPerm.maj,
          order: 2,
        },
      ];
      if (this.stock.origine !== ORIGINE_TYPE_COMMANDE
          || this.stock.type === BON_STOCK_TYPE_SORTIE) {
        actionSecondary.push(
          {
            label: this.$t('stock.actions.delete'),
            action: () => {
              this.option = 'supprimer';
              this.title = this.$t('stock.delete.titleStock', { bon: this.bon });
              this.subtitle = this.$t('general.suppression.sousTitre');
              this.popup = true;
            },
            permissionAction: this.stockPerm.supprimer,
            order: 1,
          });
      }
      return actionSecondary;
    },
    dateDeBonLibelle() {
      return this.isEntree ? this.$t(DATE_DE_BON_ENTREE) : this.$t(DATE_DE_BON_SORTIE);
    },
  },
  methods: {
    async archiverStock() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.stock.id, this.stock.actif);
        let successMessage = this.$t('stock.messages.success.archiver', { Bon: this.bon });
        if (!this.stock.actif) {
          successMessage = this.$t('stock.messages.success.desarchiver', { Bon: this.bon });
        }
        this.stock = (await get(this.$route.params.id)).data.result;
        messageSucces(successMessage);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async delete() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.stock.id);
        this.$router.push(this.route);
        const successMessage = this.$t('stock.delete.suppressionStock',
          { Bon: this.bonMaj });
        messageSucces(successMessage);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getOriginLibelle(origin) {
      return origin === ORIGINE_TYPE_DIVERS ? this.$t(ORIGINE_BON_DIVERS)
        : this.$t(ORIGINE_COMMANDE);
    },
    async action() {
      if (this.option === 'supprimer') {
        await this.delete();
        this.popup = false;
      } else if (this.option === 'archiver') {
        await this.archiverStock();
        this.popup = false;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.name === DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID) {
        this.stock = (await getByLigneCommandeId(this.$route.params.ligneCommandeId)).data.result;
      } else {
        this.stock = (await get(this.$route.params.id)).data.result;
      }
      this.isEntree = this.stock.type === BON_STOCK_TYPE_ENTREE;
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      loadingComponent.close();
    }
    this.setInformationPage(this.$t('pageStock.bonStock.detail', { bon: this.bon }));
  },
};
</script>
